var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm.plans.length == 0
      ? _c(
          "p",
          { staticClass: "fs-3 mt-3 acenter" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "preferences.Dunning.Dunning.start_automatic_dunning"
                ),
                loading: _vm.loading
              },
              on: { click: _vm.initFirstPlan }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("dunning-enable", {
              attrs: {
                enabled: _vm.enabled,
                enableLabel: _vm.$t.__("preferences.Dunning.activated"),
                disableLabel: _vm.$t.__("preferences.Dunning.disabled"),
                description: _vm.$t.__(
                  "preferences.Dunning.activation_of_automatic_restart"
                )
              },
              on: {
                "update:enabled": function($event) {
                  _vm.confirmationStatus = true
                }
              }
            }),
            _vm._v(" "),
            _c(
              "CompassDialog",
              {
                staticClass: "dunning-modal",
                attrs: {
                  visible: _vm.confirmationStatus,
                  size: "small",
                  title: _vm.confirmationTitle
                },
                on: {
                  "update:visible": function($event) {
                    _vm.confirmationStatus = $event
                  }
                }
              },
              [
                _c("template", { slot: "default" }, [
                  _c("div", { staticClass: "dialog__default" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "wordbreak typographies-paragraph-medium-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.confirmationMessage) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("template", { slot: "footer" }, [
                  _c(
                    "div",
                    { staticClass: "dialog__footer" },
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.cancel"),
                          type: "secondary"
                        },
                        on: {
                          click: function($event) {
                            _vm.confirmationStatus = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        staticClass: "ml-3",
                        attrs: {
                          label: _vm.$t.__("common.actions.confirm"),
                          type: "primary",
                          loading: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmToggle()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "well fs-3 pb-4 pt-3" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "fright w-5",
                    on: { change: _vm.setDefault },
                    model: {
                      value: _vm.defaultPlanId,
                      callback: function($$v) {
                        _vm.defaultPlanId = $$v
                      },
                      expression: "defaultPlanId"
                    }
                  },
                  [
                    _c("el-option", {
                      attrs: {
                        label: _vm.$t.__("preferences.Dunning.Dunning.none"),
                        value: 0
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.plans, function(dunning) {
                      return _c("el-option", {
                        key: dunning.id,
                        attrs: { label: dunning.name, value: dunning.id }
                      })
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("span", { staticClass: "semibold dinlineb mt-2" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Plan de relance par défaut")) +
                      "\n            "
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dunning-header bb-2" },
              [
                _c("h3", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Plans de relance")) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                !_vm.planMaximumNumber ||
                _vm.plans.length < _vm.planMaximumNumber
                  ? _c("CompassButton", {
                      staticClass: "mb-1",
                      attrs: {
                        "data-quota-guard": _vm.quotaGuard,
                        label: _vm.$t.__(
                          "preferences.Dunning.Dunning.add_dunning_plan"
                        ),
                        type: "secondary",
                        disabled: _vm.isDisableLink
                      },
                      on: { click: _vm.addPlan }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-collapse",
              {
                staticClass: "b-1 br",
                attrs: { accordion: "" },
                model: {
                  value: _vm.defaultPlanPos,
                  callback: function($$v) {
                    _vm.defaultPlanPos = $$v
                  },
                  expression: "defaultPlanPos"
                }
              },
              _vm._l(_vm.plans, function(plan, index) {
                return _c(
                  "el-collapse-item",
                  { key: plan.id, attrs: { title: plan.name, name: index } },
                  [_c("plan", { attrs: { plan: plan } })],
                  1
                )
              }),
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }